import { IScore } from './IScore';

export interface IBenchmarkScoreEntryMinimal {
  scoreBreakdown: { score: number; count: number }[];
  scoreDevelopment: {
    day: number;
    week: number;
    month: number;
  };
  growthPercentage: number;
  growthMonthPercentage: number;
  growthWeekPercentage: number;

  mostRecentReview?: Date;

  score: IScore;
}
interface IScoreEntryBase extends IBenchmarkScoreEntryMinimal {
  id: string;
  company: string;
  createdAt: string;
  updatedAt: string;
  scrapedAt: string;

  kind: 'total' | 'applicant';

  scoreDevelopment: {
    day: number;
    week: number;
    month: number;
  };

  platform: string;
}

interface HasReplies {
  reviewsWithComment: number;
  replyRate: number;
  avgReplyTime: number;
  avgReplyRate: number;
}
interface HasRecommends {
  recommendationDevelopment: {
    day: number;
    week: number;
    month: number;
  };
}

export type IScoreEntryWithReplies = IScoreEntryBase & HasReplies;

export type IScoreEntryWithRecommends = IScoreEntryBase & HasRecommends;

export type IScoreEntryFull = IScoreEntryBase & HasReplies & HasRecommends;

export type IScoreEntry = IScoreEntryWithReplies | IScoreEntryWithRecommends | IScoreEntryFull;

export function hasReplies(
  entry: IBenchmarkScoreEntryMinimal
): entry is IScoreEntryWithReplies | IScoreEntryFull {
  if (!entry) {
    return false;
  }
  return 'avgReplyRate' in entry;
}

export function hasRecommends(
  entry: IBenchmarkScoreEntryMinimal
): entry is IScoreEntryWithRecommends | IScoreEntryFull {
  return 'recommendation' in entry.score && 'recommendationDevelopment' in entry;
}
